export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";